import { render, staticRenderFns } from "./AsyncComponent.vue?vue&type=template&id=e57b0a18&scoped=true&"
import script from "./AsyncComponent.vue?vue&type=script&lang=js&"
export * from "./AsyncComponent.vue?vue&type=script&lang=js&"
import style0 from "./AsyncComponent.vue?vue&type=style&index=0&id=e57b0a18&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e57b0a18",
  null
  
)

export default component.exports